import PurposeSelect, {
  type PurposeOption,
} from "@/components/form/purpose-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is the whole purpose object**, not its id. */
export type OrderPurposeFieldProps = PickerFieldProps<PurposeOption>;

export const OrderPurposeField = makePickerField<PurposeOption>({
  name: "OrderPurposeField",
  control: PurposeSelect,
  popout: true,
});
